import { defineType } from "sanity";

interface Srt {
  url?: string;
  path?: string;
  mimetype?: string;
}

export interface Caption {
  language?: string;
  srt?: Srt;
}

export const sanctuaryCaptions = defineType({
  type: "array",
  of: [{ type: "captionType" }],
  name: "sanctuaryCaptions",
  title: "Sanctuary Captions"
});
